import { getEmployeeOfficeHierarchyLeadership } from "actions/Employees";
import { useQuery } from "react-query";

export const useGetEmployeeOfficeHierarchyLeadership = (employeeId) => {
  return useQuery(
    ["GetEmployeeOfficeHierarchyLeadership", employeeId],
    () => getEmployeeOfficeHierarchyLeadership(employeeId),
    { refetchOnWindowFocus: false }
  );
};
